import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { fields } from 'src/components/utils/fields'
import { useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_Button, M_Fieldset, M_Header, M_MessageBoard, NavigateContext } from 'src/M_Components'
import { FileOpenOutlined, Refresh } from '@mui/icons-material'


export const EquipmentLeasingCrud = () => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [data, setData] = useState({})
        
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [leavingPage, setLeavingPage] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [editingId, setEditingId] = useState(null) 

    const equipmentLeasingService = new BufferService('EquipmentLeasing', 'secondary')

    const sessionKeys = ['operation', 'data', 'open', 'passedRow', 'leavingPage']

    const matches = useMediaQuery('(min-width:1800px)')
    const matches2 = useMediaQuery('(min-width:1700px)')
    const matches3 = useMediaQuery('(min-width:1490px)')
    const matches4 = useMediaQuery('(min-width:1450px)')
    const matches5 = useMediaQuery('(min-width:1420px)')
    const matches6 = useMediaQuery('(min-width:1380px)')
    const matches7 = useMediaQuery('(min-width:1280px)')
    const matches8 = useMediaQuery('(min-width:1230px)')
    const matches9 = useMediaQuery('(min-width:1190px)')
    const matches10 = useMediaQuery('(min-width:1150px)')
    const matches11 = useMediaQuery('(min-width:970px)')
    const matches12 = useMediaQuery('(min-width:930px)')
    const matches13 = useMediaQuery('(min-width:850px)')
    const matches14 = useMediaQuery('(min-width:870px)')
    const matches15 = useMediaQuery('(min-width:615px)')
    const matches16 = useMediaQuery('(min-width:440px)')


    const EquipmentLeasingFields = [
        { display: t('Equipment')+' '+('Leasing')+' '+t('Code'), required: true, code: 'contractCode', type: 'text'},
        { display: t('Equipment')+' '+('Leasing')+' '+t('Name'), required: true, code: 'contractName', type: 'text'},
    ]


    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))

            const editingEquipmentLeasing = JSON.parse(sessionStorage.getItem('editingEquipmentLeasing'))
            const operationType = sessionStorage.getItem('operationType')
            
            if (editingEquipmentLeasing && (operationType === 'Edit' || operationType === 'Copy')) {
                editOrCopyEquipmentLeasing(editingEquipmentLeasing.Id, operationType === 'Copy')
                
                sessionStorage.removeItem('editingEquipmentLeasing')
                sessionStorage.removeItem('operationType')
            } else if (operationType === 'Create') {
                setOperation('Create')
                sessionStorage.removeItem('operationType')
            }
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, operation, data, leavingPage])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        if (eval(value) instanceof Number && eval(value) === '') return

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))
        const tempLP = JSON.parse(sessionStorage.getItem(`${sessionID}leavingPage`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0) || tempOS || (tempPR && Object.keys(tempD).length !== 0)) {

            setOperation(new String(tempO))
            setData(new Object(tempD))
            setOpen(tempOS)
            setPassedRow(tempPR)
            setLeavingPage(tempLP || false)
            ctx.setIsLoad(false)

            return
        }
        get()
    }

    const get = () => {
        ctx.setIsLoad(false)
    }

    const refreshEquipmentLeasing = () => {
        ctx.setIsLoad(true)
        
        sessionKeys.forEach(key => {
            sessionStorage.removeItem(`${id}${key}`)
        })
        
        // Initial values
        setData({})
        setPassedRow({})
        setOpen(false)
        setOperation('')
        setLeavingPage(false)
        setIsEditMode(false)
        setEditingId(null) 
        
        get()
        
        ctx.setIsLoad(false)
        ctx.toastMessages('success', t('Form refreshed'), '')    
    }

    const checkEquipmentLeasingExists = async (contractCode) => {
        if (!contractCode) return false
        
        try {
            const response = await equipmentLeasingService.filter(`?filter=ContractCode eq '${contractCode}'`)
            
            if (response.name === 'AxiosError' || !response.Items) {
                return false
            }
            
            const exactMatch = response.Items.find(item => item.ContractCode === contractCode)
            
            return !!exactMatch

        } catch (error) {
            console.error('Error checking equipment leasing:', error)
            return false
        }
    }

    const onSave = async () => {

        // Validations
        if (!data.contractCode || !data.contractName) {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }

        if (!isEditMode || (isEditMode && data.contractCode !== data._originalCode)) {
            ctx.setIsLoad(true)
            const exists = await checkEquipmentLeasingExists(data.contractCode)
            ctx.setIsLoad(false)
            
            if (exists) {
                ctx.toastMessages('error', '', `${t('Equipment')} ${t('Leasing')} ${data.contractCode} ${t('already exists')}`)
                return
            }
        }
        
        const equipmentLeasingData = {
            ContractCode: data.contractCode,
            ContractName: data.contractName,
        }
        
        ctx.setIsLoad(true)

        const savePromise = isEditMode && editingId 
            ? equipmentLeasingService.update(editingId, equipmentLeasingData)
            : equipmentLeasingService.post(equipmentLeasingData)
        
        savePromise.then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                handleError(response)
                return
            }
            
            // Success
            const successMessage = isEditMode ? `${t('Equipment')} ${t('Leasing')} ${t('updatedSuccessfully')}` : `${t('Equipment')} ${t('Leasing')} ${t('savedSuccessfully')}`
            ctx.toastMessages('success', '', successMessage)
            
            ctx2.closeTab(JSON.parse(id))
            
        }).catch(error => {
            ctx.setIsLoad(false)
            handleError(error)
        })
    }

    const editOrCopyEquipmentLeasing = (equipmentLeasingId, isCopy = false) => {
        ctx.setIsLoad(true)
        
        equipmentLeasingService.getId(equipmentLeasingId).then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '', `${t('Equipment')} ${t('Leasing')} ${t('Failed to load')}`)
                return
            }
            
            // Mapper
            const equipmentLeasingData = {
                contractCode: isCopy ? '' : (response.ContractCode?.toString() || ''),
                contractName: response.ContractName,

                _originalCode: response.ContractCode?.toString() || '',
                _isCopy: isCopy,
                _originalId: isCopy ? equipmentLeasingId : null
            }

            if (isCopy) {
                delete equipmentLeasingData.Id
                delete equipmentLeasingData.ExternalId
                delete equipmentLeasingData.CreatedAt
                delete equipmentLeasingData.UpdatedAt

                setIsEditMode(false)  
                setEditingId(null)        
                setOperation('Create')    
            } else {
                setIsEditMode(true)         
                setEditingId(equipmentLeasingId) 
                setOperation('Edit')      
            }

            setData(equipmentLeasingData)
                
        }).catch(error => {
            ctx.setIsLoad(false)
            console.error('Error loading equipment:', error)
            ctx.toastMessages('error', '', `${t('Equipment')} ${t('Leasing')} ${t('Failed to load')}`)
        })
    }
    
    const handleError = (error) => {
        
        let errorMessage = t('Error saving')+' '+t('Equipment')+' '+t('Leasing')
        if (Array.isArray(data)) {
                errorMessage = data.map(e => `${e.field}: ${e.message}`).join('\n')
            } else if (data?.errors) {
                errorMessage = Object.entries(data.errors)
                    .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                    .join('; ')
            } else if (data?.message) {
                errorMessage = data.field ? `${data.field}: ${data.message}` : data.message
            } else if (data?.detail) {
                errorMessage = data.detail
            } else if (data?.title) {
                errorMessage = data.title
            } else if (error.message) {
                errorMessage = error.message
            }

            ctx.toastMessages('error', '', errorMessage)
    }


    return (
        <div >
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        <M_Button
                            tooltip={t("Refresh")}
                            icon={<Refresh />}
                            label={t("Refresh")}
                            onClick={() => refreshEquipmentLeasing()}
                        />
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save "></i>}
                            label={t("Save")}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />
            <div style={{ margin: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><FileOpenOutlined style={{ marginRight: '10px', scale: '1.3' }} /> {t('Equipment')+' '+t('Leasing')+' '+t('Details')}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches16 && 'auto' || 'auto auto', justifyContent: 'space-evenly' }}>
                                {EquipmentLeasingFields.map((field, index) => {
                                    return fields(field, index, data, setData, null, null, '120%')
                                })}
                            </div>
                        }
                    />
                </div>
                <div style={{ margin: '25px' }}></div>
            </div >
            <M_MessageBoard
                warning
                open={leavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBody")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => { ctx2.closeTab(JSON.parse(id)); setLeavingPage(false) }} label={t("ButtonConfirm")} />
                    </span>
                }
            />
        </div >
    )
}
